import { Component, inject, Input, OnInit, Signal, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { InvoicingService, ISaleStatus } from '../../core/services/invoicing.service';
import { UserService } from '../../core/services/user.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { StoresService } from '../../core/services/stores.service';
import { IconComponent } from '../../shared-with-client/icon/icon.component';
import { ButtonComponent } from '../../shared-with-client/button/button.component';
import { SalesStatusComponent } from '../invoicing/sales-status/sales-status.component';
import { DatePipe } from '@angular/common';
import { MerchantCurrencyPipe } from '../../shared/pipes/merchant-currency.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { InvoicePreviewComponent } from "../invoicing/invoice-preview/invoice-preview.component";
import { SaleDetailDocumentsComponent } from "../invoicing/sale-detail-documents/sale-detail-documents.component";
import { SaleDetailActionsComponent } from "../invoicing/sale-detail-actions/sale-detail-actions.component";

@Component({
    selector: 'app-client-sales',
    imports: [IconComponent, ButtonComponent, SalesStatusComponent, DatePipe, MerchantCurrencyPipe, TranslatePipe, InvoicePreviewComponent, SaleDetailDocumentsComponent, SaleDetailActionsComponent],
    templateUrl: './client-sales.component.html',
    styleUrl: './client-sales.component.scss',
})
export class ClientSalesComponent implements OnInit {
    @Input() client: any;

    private userService = inject(UserService);
    private storesService = inject(StoresService);
    private invoicingService = inject(InvoicingService);
    private modalService = inject(BsModalService);

    public ISaleStatus = ISaleStatus;

    public currentUser: Signal<any> = toSignal(this.userService.currentUser);
    public currentStore = toSignal(this.storesService.getActiveStore());

    public loading = signal<boolean>(true);
    public salesData = signal<any>(null);

    public isInvoicingActive = toSignal(this.storesService.isInvoicingActive());

    ngOnInit() {
        this.getClientSales();
    }

    getClientSales() {
        this.loading.set(true);
        this.invoicingService.getClientSales(this.client.id, this.currentStore().id).subscribe((sales) => {
            this.salesData.set(sales);
            this.loading.set(false);
        });
    }

    saleUpdated() {
        this.getClientSales();
    }

    closeModal() {
        this.modalService.hide();
    }

}
